import { useQuery } from '@tanstack/react-query';
import { consumerApi } from '../api/consumer-api';

/** Fetches a fresh download link for a policy review document and sends the browser to it. */
export function usePolicyReviewDocumentDownload(reviewId: string, documentIndex: number) {
  const download = useQuery({
    queryKey: ['consumerPolicyReviewDocument', reviewId, documentIndex],
    queryFn: async () => {
      const { url } = await consumerApi.getPolicyReviewDocumentDownloadUrl(reviewId, documentIndex);
      window.location.assign(url);
      return url;
    },
    enabled: Number.isInteger(documentIndex),
    retry: false,
    staleTime: Infinity,
  });

  return { isLoading: download.isLoading, isError: download.isError };
}
